import { useCallback } from "react";
import { format } from "date-fns";

export type DateFormatStyle = "short" | "long" | "timeOnly" | "dateOnly";

export function useFormatDate() {
  const formatDate = useCallback(
    (dateInput: string | Date, style: DateFormatStyle = "long") => {
      const date =
        typeof dateInput === "string" ? new Date(dateInput + "Z") : dateInput;

      switch (style) {
        case "short":
          return format(date, "MMM d, h:mm a"); // "Sep 13, 3:25 AM"
        case "timeOnly":
          return format(date, "h:mm a"); // "3:25 AM"
        case "dateOnly":
          return format(date, "MMM d, yyyy"); // "Sep 13, 2025"
        case "long":
        default:
          return format(date, "MMM d, yyyy h:mm a"); // "Sep 13, 2025 3:25 AM"
      }
    },
    []
  );

  return { formatDate };
}
